import './RouteFallback.css'

/**
 * What a route transition shows while its chunk is downloading.
 *
 * The three Suspense boundaries in App.jsx used `fallback={null}`, so the app went blank
 * between routes — and the longest of those transitions is the one right after a Google
 * sign-up, where a blank screen is indistinguishable from a sign-in that failed. This does not
 * make anything faster; it makes the wait legible.
 *
 * See RouteFallback.css for why nothing is drawn for the first 280ms.
 */
export default function RouteFallback() {
  return (
    <div className="route-fallback" role="status" aria-live="polite">
      <span className="route-fallback-spinner" aria-hidden="true" />
      <span className="route-fallback-label">Loading</span>
    </div>
  )
}
